import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeCarcompany extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  carcompany_id: "",
                  carcompany_name: "",
                  carcompany_priority: "",
                  selectedCarMode: "",
                  optionCarMode: [],

                  carcompany_deactive: "1",
                  carcompany_logo: "",
                  orderBy: "carcompany_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newCarcompany: true,
                  picturesRequestReady: "",
                  loading: false,
                  percent: 0,
            }
      }

      handleCarMode = (selectedCarMode) => {
            this.setState({ selectedCarMode: selectedCarMode }, () => {
                  this.filterFieldCompany()
            })
      }

      handleChangeCarcompanyName = (event) => {
            this.setState({ carcompany_name: event.target.value })
      }

      onSelectPicRequest = (picture) => {
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }

      handlecarcompany_priority = (event) => {
            this.setState({ carcompany_priority: event.target.value })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ carcompany_deactive: "0" })
            } else {
                  this.setState({ carcompany_deactive: "1" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        carcompany_id: row2.carcompany_id,
                        carcompany_name: row2.carcompany_name,
                        carcompany_priority: row2.carcompany_priority,
                        selectedCarMode: { value: row2.carcompany_carmode_id, label: row2.carmode_name },

                        carcompany_deactive: row2.carcompany_deactive,
                        carcompany_logo: row2.carcompany_logo,
                        newCarcompany: false,
                  },
                  () => {}
            )
      }

      newCarcompany = (event) => {
            this.setState({
                  carcompany_id: "",
                  carcompany_name: "",
                  carcompany_priority: "",
                  carcompany_deactive: "0",
                  carcompany_logo: "",
                  newCarcompany: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getCarcompany()
                                    self.getoptionCarMode()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getoptionCarMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].carmode_id, label: arr.data[k].carmode_name })
                              }
                              self.setState({ optionCarMode: Company, selectedCarMode: Company[0] }, () => {
                                    self.filterFieldCompany()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_carmode")
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getCarcompany() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterFieldCompany()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_carcompany")

            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewCarcompany = (imageCode) => {
            const { carcompany_id, carcompany_name, selectedCarMode, carcompany_priority, carcompany_deactive } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getCarcompany()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_carcompany")
            fd.append("carcompany_name", carcompany_name)
            fd.append("carcompany_priority", carcompany_priority)
            fd.append("carcompany_logo", imageCode)
            fd.append("carcompany_carmode_id", selectedCarMode.value)
            fd.append("carcompany_deactive", carcompany_deactive)

            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeCarcompany = (imageCode) => {
            const { carcompany_id, carcompany_name, selectedCarMode, carcompany_priority, carcompany_deactive } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getCarcompany()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            console.log(carcompany_deactive)
            var fd = new FormData()
            fd.append("command", "modify_carcompany")
            fd.append("carcompany_id", carcompany_id)
            fd.append("carcompany_name", carcompany_name)
            fd.append("carcompany_priority", carcompany_priority)
            fd.append("carcompany_logo", imageCode)
            fd.append("carcompany_carmode_id", selectedCarMode.value)
            fd.append("carcompany_deactive", carcompany_deactive)
            if (imageCode !== "") {
                  fd.append("carcompany_logo", imageCode)
            }

            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      uploadPicDelivery = (mode) => {
            const { carcompany_name, carcompany_priority, carcompany_deactive, selectedCarMode } = this.state
            const { picturesRequestReady } = this.state
            if (carcompany_priority != "" && carcompany_name != "") {
                  if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          if (mode === "new") {
                                                self.saveNewCarcompany(arr.data["image_code"])
                                          } else {
                                                self.changeCarcompany(arr.data["image_code"])
                                          }
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", picturesRequestReady)
                        fd.append("image_name", " تصویر برند " + carcompany_name)
                        fd.append("image_desc", "تصویر برند " + carcompany_name)
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        console.log(mode)
                        if (mode === "new") {
                              this.saveNewCarcompany("")
                        } else {
                              this.changeCarcompany("")
                        }
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات برند را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      filterFieldCompany = () => {
            const { selectedCarMode, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (temparray[i].carcompany_carmode_id === selectedCarMode.value) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  optionCarMode,
                  selectedCarMode,
                  carcompany_priority,
                  loading,
                  percent,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newCarcompany,
                  carcompany_id,
                  carcompany_name,
                  carcompany_logo,
                  carcompany_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نوع اتوموبیل </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع اتوموبیل"}
                                                                              value={selectedCarMode}
                                                                              onChange={this.handleCarMode}
                                                                              options={optionCarMode}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی برند:" + carcompany_id}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="برند نمایش"
                                                                        handleInputt={this.handleChangeCarcompanyName}
                                                                        value={carcompany_name}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="اولویت نمایش"
                                                                        handleInputt={this.handlecarcompany_priority}
                                                                        value={carcompany_priority}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={carcompany_logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={carcompany_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت برند"
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="عکس را انتخاب نمایید"
                                                                        onChange={this.onSelectPicRequest}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  {loading && <LinearProgress variant="determinate" value={percent} />}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newCarcompany ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.uploadPicDelivery("new")
                                                                              }}
                                                                        >
                                                                              {"ثبت برند جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button variant="outlined" color="primary" onClick={this.newCarcompany}>
                                                                                    {"برند جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("modify")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell></TableCell>

                                                                              <TableCell
                                                                                    key={"carcompany_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "carcompany_id" ? order : false}
                                                                              >
                                                                                    {"آیدی برند "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "carcompany_id"}
                                                                                          direction={orderBy === "carcompany_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("carcompany_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"carcompany_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام برند "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "carcompany_name"}
                                                                                          direction={orderBy === "carcompany_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("carcompany_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"carcompany_priority"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" اولویت نمایش "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "carcompany_priority"}
                                                                                          direction={
                                                                                                orderBy === "carcompany_priority" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("carcompany_priority")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"carcompany_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت برند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "carcompany_deactive"}
                                                                                          direction={
                                                                                                orderBy === "carcompany_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("carcompany_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["carcompany_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt=""
                                                                                                            src={row["carcompany_logo"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"carcompany_id"} align={"center"}>
                                                                                                      {row["carcompany_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"carcompany_name"} align={"center"}>
                                                                                                      {row["carcompany_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"carcompany_priority"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["carcompany_priority"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"carcompany_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["carcompany_deactive"] === "1" ||
                                                                                                      row["carcompany_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeCarcompany)
